import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import * as React from 'react';

import { FieldName } from '../models/SearchField';

export interface Props {
  availableOptions: (FieldName)[];
  onSelect: (searchField: FieldName) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      width: '100%',
      minHeight: 48,
      textTransform: 'none',
      borderStyle: 'dashed',
      color: theme.palette.grey[400],
      justifyContent: 'start'
    },
    icon: {
      marginRight: theme.spacing(1)
    }
  })
);

const SearchFieldNew: React.FC<Props> = ({ availableOptions, onSelect }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleItemClose = (selectedOption: FieldName) => {
    onSelect(selectedOption);
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        size="small"
        className={classes.button}
        variant="outlined"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <AddIcon className={classes.icon} />
        Field
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted={true}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        {availableOptions.map(availableOption => {
          return (
            <MenuItem key={availableOption} onClick={handleItemClose.bind(null, availableOption)}>
              {availableOption}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default SearchFieldNew;
